module.exports = __webpack_public_path__ + "img/ep8-4.87c86796.png";